// Third-party
import { useTranslation } from 'react-i18next';
import startCase from 'lodash/startCase';

// Components
import { BaseDialog, TDialogAction } from '@mgm/common/components/base';

// Hooks
import { useDeleteTasklistAPI } from '../../Shared/hooks/api';
import { useAppDispatch, useAppSelector } from '../../../../hooks/useAppStore';

// Redux-toolkit
import {
  getIsOpenDeleteDialog,
  getSelectedTasklistForAction,
  getTasklists,
} from '../../../../store/tasklists/selectors';
import { tasklistsActions } from '../../../../store/tasklists/slice';

const DeleteTasklist = () => {
  const { t } = useTranslation(['common', 'tasklists']);
  const { mutateAsync, isLoading } = useDeleteTasklistAPI();
  const selectedTasklistForAction = useAppSelector(getSelectedTasklistForAction);
  const isOpenDeleteDialog = useAppSelector(getIsOpenDeleteDialog);
  const tasklists = useAppSelector(getTasklists);
  const dispatch = useAppDispatch();

  const handleCloseDialog = () => {
    dispatch(tasklistsActions.setIsOpenDeleteDialog(false));
    dispatch(tasklistsActions.setSelectedTasklist(tasklists[0]));
  };
  const deleteTasklist = async () => {
    await mutateAsync(selectedTasklistForAction.id);
    handleCloseDialog();
  };

  const dialogActions: Array<TDialogAction> = [
    {
      label: t('cancel', { ns: 'common' }),
      variant: 'outlined',
      color: 'primary',
      isDisabled: isLoading,
      onClick: () => handleCloseDialog(),
    },
    {
      label: t('delete', { ns: 'common' }),
      color: 'primary',
      isLoading,
      onClick: () => deleteTasklist(),
    },
  ];

  return (
    <BaseDialog
      dialogContent={t('deleteTasklistContent', { ns: 'tasklists', name: startCase(selectedTasklistForAction.title) })}
      isOpenDialog={isOpenDeleteDialog}
      dialogTitle={t('deleteTasklist', { ns: 'tasklists' })}
      handleClose={handleCloseDialog}
      dialogActions={dialogActions}
    />
  );
};

export {
  DeleteTasklist,
};
